export default {
    loading: {
        module: true
    },
    params: {
        from_date: '',
        difer: 0.2,
    },
    data_report:[],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/inventory-reconciliation/state.js